import { AuthService, ErrorService } from '@akeela/auth';
import { UploadService } from '@akeela/common';
import { I18nPipe, I18nService } from '@akeela/i18n';
import { LocalService } from '@akeela/local-storage';
import { HttpService } from '@akeela/properties';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../../environments/environment';
import swal from 'sweetalert2';
import { Observable, Subscription, timer } from 'rxjs';
import { AkeelaSidebarMenuService } from '@akeela/menu';
import { isNullOrUndefined } from 'util';
import { EmailService } from 'src/app/services/email.service';
import { Utf8RegexService } from 'src/app/services/utf8-regex.service';


@Component({
  selector: 'akeela-meet',
  templateUrl: './akeela-meet.component.html',
  styleUrls: ['./akeela-meet.component.css']
})
export class AkeelaMeetComponent implements OnInit,OnDestroy {

  _second = 1000;
  _minute = this._second * 60;
  _hour = this._minute * 60;
  _day = this._hour * 24;
  end: any;
  now: any;
  day: any;
  hours: any;
  minutes: any;
  seconds: any;
  source = timer(0, 1000);
  clock: any;

  env = environment;
  animate_init = true;
  animate_init_bottom = true;
  buttomModal;
  clientDetail;
  init_meet;
  back = false;
  menuSelect = false;
  shared =  false;
  newInterview = false
  dataAndSelfi;
  filePreview;
  client;
  dataIdentity;
  compleatVerifi;
  loading;
  loadingTransaction;
  dataInformation;
  verifiedIdentification;
  copy;
  interviews = [];
  interviewsObj= {};
  rows = [];
  transactions;
  interviewTypeIcon = [];
  interviewType = [];
  formsDataResponse = {};
  interviewsTime={};
  editMeetInput;
  editMeetInputLoading;
  showLink;
  meetNew =true;
  emailSubscription: Subscription;
  sendMailSubscription:Subscription;
  @Output() change = new EventEmitter();
  dataInformationsSubscription: Subscription;

  @Input() set username(client) {
    this.clientDetail = [];
          if (client) {
        this.dataAndSelfi = null;
        this.filePreview = null;
        this.init_meet = false;

        this.client = client;
        this.get_dataAndSelfi();
       // this.get_data_identity();
        this.getUser();
        this.getTransactions();
  
        this.init_meet = false;
      }
    }
  

  @Input() set selected(buttomModal) {
    if (buttomModal) {

      let html =  document?.getElementById("idHtml");
      html?.classList?.add('scroll-none');
  
      this.buttomModal = true;
      this.animate_init_bottom = false;
    }
  }


  @Input() transactionedit?;
  constructor(
    private _httpService: HttpService,
    private i18n: I18nPipe,
    private _upload: UploadService,
    private datePipe: DatePipe,
    private _auth: AuthService,
    private sanitizer: DomSanitizer,
    private localStorage: LocalService,
    private error: ErrorService,
    public _akeelaSidebarMenu: AkeelaSidebarMenuService,
    private _email: EmailService,
    private _i18n: I18nService,
    private i18nPipe: I18nPipe,
    private _utf8: Utf8RegexService,

  ) { }

  ngOnInit(): void {


     
    if(this.transactionedit){
     this.editMeetInputLoading = true;
    }


    this.formsDataResponse = {
      interviewDate: '',
      description: '',
      idTransaction:'',
      modifyUser:this._auth?.getUsername(),
      type:'3'
    }
  }

  showDate(idTransaction){
    let distance = this.interviewsTime[idTransaction]['end'] - this.interviewsTime[idTransaction]['now'];
    this.interviewsTime[idTransaction]['day'] = Math.floor(distance / this._day);
    this.interviewsTime[idTransaction]['hours']  = Math.floor((distance % this._day) / this._hour);
    this.interviewsTime[idTransaction]['minutes']  = Math.floor((distance % this._hour) / this._minute);
    this.interviewsTime[idTransaction]['seconds']  = Math.floor((distance % this._minute) / this._second);
  }

   epoch (value) {

    let date =  this.parseDateString(value);
    return +date;

  }

  private parseDateString(date:string): Date {
    date = date.replace('T','-');
    let parts:any = date.split('-');
    let timeParts = parts[3].split(':');
    
   // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
    return new Date(parts[0], parts[1]-1, parts[2], timeParts[0], timeParts[1]); // Note: months are 0-based

 }

  get_data_identity() {

    const params = {
      name: 'person$get_data_identity$get',
      params: {
        request: {
          'username': this.client
        },
        path: {},
        body: {}
      }
    };



    this._httpService.executeRequest(params.name, params.params, true).subscribe((response: any) => {

      this.dataIdentity = response;



    });

  }


  get_dataAndSelfi() {

    const params = {
      name: 'person$selfie$get',
      params: {
        request: {
          'username': this.client
        },
        path: {},
        body: {}
      }
    };



    this._httpService.executeRequest(params.name, params.params, true).subscribe((response: any) => {

      this.dataAndSelfi = response;
      this.filePreview = 'data:image/jpg' + ';base64,' + response?.description;

    });


  }

  redirectMeet(url:any = false){

    let data  = 'https://meet.jit.si/meet-'+this.env.theme.images+'-'+this.clientDetail?.identifier;
   
    if(url){
      data = url;
    }
   
    // Abrir nuevo tab
    var win = window.open(data, '_blank');
    // Cambiar el foco al nuevo tab (punto opcional)
    this.resetMenu();
    win.focus();

}

setClientDetail(e) {


}


changes() {
  let html =  document?.getElementById("idHtml");
  html?.classList?.remove('scroll-none');

  this.buttomModal = false;
  this.change.emit(false);
}


setUserDetail() {

  this.buttomModal = false;
  this.change.emit(this.client);
}



setMenuSelect(){
  this.resetMenu();
  this.menuSelect = true;
  this.back = true;
}

setShared(){
  this.resetMenu();
  this.shared = true;
  this.back = true;
}

setNewInterview(idTransaction:any = ''){


  if(idTransaction){
    this.setformTransaction(idTransaction);

  }else{

    this.formsDataResponse = {
      interviewDate: '',
      description: '',
      idTransaction:'',
      modifyUser:this._auth?.getUsername(),
      type:'3'
    }
  
  }

  this.resetMenu();
  this.newInterview = true;
  this.back = true;
}


setBack(){
  this.resetMenu();
  this.back = false;

}

resetMenu(){
  this.menuSelect = false;
  this.shared = false;
  this.newInterview = false;
  this.back = false;
  this.copy = false;


}


getUser() {
  const params = {
    name: 'person$enduser$get',
    params: {
      request: {
        'username': this.client
      },
      path: {},
      body: {}
    }
  };


  this.loading = true;

  this._httpService.executeRequest(params.name, params.params, true).subscribe((response: any) => {

    this.clientDetail = response;



    this.loading = false;

    this.compleatVerifi = response ?.person ?.completeIdentification ;
    this.verifiedIdentification = response ?.person ?.verifiedIdentification ;
    this.getDataInformations();

  });

}



getTransactions() {
  this.loadingTransaction = true;
  const params = {
    name: 'account$myformalities_paginated$get',
    params: {
      request: {
        page: 0,
        size: 60
      },
      path: {
        username: this.client
      },
      body: {}
    }
  };

  this._httpService.executeRequest(params.name, params.params, true).subscribe((response: any) => {

    this.transactions = response.content;
    this.rows = [];

    for (const transaction of this.transactions) {

      let row = transaction;

      let jsonTmp =
        {
          "identifier": row.identifier,
          "solicitud": row.transactionNumber,
          "fecha": (row.accountStatus) ? (this.datePipe.transform(row.accountStatus[0].dateOfThing.startDate, 'dd/MM/yyyy')) : '-',
        }

      this.rows = [...this.rows, jsonTmp];

      this.getInterview(row?.identifier, row?.transactionNumber);
    }

    this.interviews= [];
    this.interviewsObj = {};
    this.getInterviewType();
   this.loadingTransaction = false;
   

  }, error => {
    this.loadingTransaction = false;

  });
}



setCopy(text){
  navigator.clipboard.writeText(text);
  this.copy =  true;
}

setShare(url,row:any =false){

  if (navigator.share) {

    let text = this.env?.theme?.images +" Video LLamada.";

    if(row){
      text = this.env?.theme?.images +". Fue programada una reunion de tipo ( "+ this.i18n.transform(row?.tipo)+") en fecha "+ this.datePipe.transform(row?.fecha, 'd MMM, y h:mm a');
    }

    if(url){
      navigator.share({  text: text , url: url });

    }else{
      navigator.share({text: text});

    }

  }


}


 convertUTCDateToLocalDate(date) {
  var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);

  var offset = date.getTimezoneOffset() / 60;
  var hours = date.getHours();

  newDate.setHours(hours - offset);

  return newDate;   
  
}


 toDateString(fecha): string {
 let temp2 = this.convertUTCDateToLocalDate(new Date(fecha)).toISOString().slice(0, 16);

//  let temp = new Date(fecha).toISOString().slice(0, 16); 
     let date:Date = this.parseDateString(temp2);
  return (("0" + (date.getDate())).slice(-2) + '/' + ("0" + (date.getMonth() + 1)).slice(-2) + '/' +date.getFullYear().toString())
   + ' ' + date.toTimeString().slice(0,5);
}


private toDateStringTime(fecha): string {
  let temp = this.convertUTCDateToLocalDate(new Date(fecha)).toISOString().slice(0, 16); 
  let date:Date = this.parseDateString(temp);

  return (  ("0" + (date.getMonth() + 1)).slice(-2)  + '/' + ("0" + (date.getDate())).slice(-2)  + '/' +date.getFullYear().toString())
   + ' ' + date.toTimeString().slice(0,5);
}


setformTransaction(idTransaction){

  let temp = this.interviewsObj[idTransaction];

  if(temp){


  //let fecha =this.datePipe.transform(temp?.interviewDate, 'd-M-yyTh:mm');

  let fecha = this.convertUTCDateToLocalDate(new Date(temp?.interviewDate)).toISOString().slice(0, 16);
    this.formsDataResponse['interviewDate'] =  fecha;
    this.formsDataResponse['type'] =  temp?.type;
    this.formsDataResponse['description'] =  temp?.description;
    this.formsDataResponse['idTransaction'] =  idTransaction;
  }

}

  getInterview(transaction,transactionNumber) {
      
    const params = {
      name: 'interview$interviews_transaction$get',
      params: {
        request: {
          idTransaction: transaction
        },
        path: { 

        },
        body: {}
      }
    };

       this._httpService.executeRequest(params.name, params.params, true).subscribe((response: any) => {
      if(response){
        response['transaction'] = transactionNumber; 
        response['idTransaction'] = transaction;

        this.interviews = [...this.interviews, response];

        this.interviewsObj[transaction] = response;
        this.setTimeInterview(response);

        
        if(this.transactionedit && this.transactionedit == transaction){
          this.setNewInterview(this.transactionedit);
          this.editMeetInput = true;
          this.editMeetInputLoading = false;
      
        }

      }

    }, error => {
    });

  }

  setTimeInterview(response){
    this.interviewsTime[response?.idTransaction]= {
      now:'',
      end:'',
      day:'',
      hours:'',
      minutes:'',
      seconds:'',
      valid:''
    }
  
    this.clock = this.source.subscribe(t => {
      this.interviewsTime[response?.idTransaction]['now'] = new Date();
    //  this.end = new Date('01/01/' + (this.now.getFullYear() + 1) +' 00:00');

    let temp = this.toDateStringTime(response?.interviewDate);
   // let temp2 = '01/01/' + (this.interviewsTime[response?.idTransaction]['now'].getFullYear() + 1) +' 00:00';

    this.interviewsTime[response?.idTransaction]['end'] = new Date(temp);
    this.interviewsTime[response?.idTransaction]['valid'] = this.interviewsTime[response?.idTransaction]['end'] > this.interviewsTime[response?.idTransaction]['now'];
     // this.interviewsTime[response?.idTransaction]['end'] = this.toDateString(response?.interviewDate);
    if(this.interviewsTime[response?.idTransaction]['valid']){
      this.showDate(response?.idTransaction);
    }

    });
  }



  getInterviewType() {    
    const params = {
      name: 'workflow_manager$attributes_options$get',
      params: {
        request: {},
        path: { 
          code: 'interviewType'
        },
        body: {}
      }
    };
    
  
    this._httpService.executeRequest(params.name, params.params, true).subscribe((response: any) => {
      let nameItem = '';

      if(response.length){


        this.interviewType = [];
        for (let value of response) {
          nameItem = value.item.alternateName;
        if(nameItem){

          this.interviewType[nameItem] =   {value:nameItem, label: value.name} ;

        }
                  


        }}
    
      });

  }




  submitFormsDataResponse(){
    let formsDataResponse:any = this.formsDataResponse

   formsDataResponse['interviewDate'] =   this.epoch(this.formsDataResponse['interviewDate']);
    const params = {

      name: "interview$interviewuser$post",
      params: {
        request: {
          role: this.localStorage.getItem('role'),
          audience: this.localStorage.getItem('audience')
        },
        path: {},
        body: formsDataResponse
      }
    };
            this._httpService.executeRequest(params.name, params.params, true).subscribe((response: any) => {
  
              this.emailCrearMeet(formsDataResponse);


              swal.fire({
                reverseButtons: true,
                confirmButtonText: 'Ok',
                html: 'Reunión agendada',
              });

              this.getTransactions();
              this.setBack();
  
            }, error => {
             
              this.error.show(error, this.i18n.transform('Alerta!'), this.i18n.transform('No se pudo dar respuesta a esta Solicitud  <br><b>'));
            });
            

    
  }

  
  sendMail(text ) {

   let data = this.clientDetail;
   let emailTo = data?.person?.email;

    return new Observable(resolve => {
      const portal = environment.theme.site.name;
      const properties: object = {};
      properties['template'] = 'templates/' + this._i18n.lang + '/createmeet.html';

      let site_header = environment.theme.site.name;
      if (!isNullOrUndefined(environment.theme.image)) {
        if (!isNullOrUndefined(environment.theme.image.active)) {
          if (environment.theme.image.active) {
            site_header = '<img src="' + environment.theme.image.urlImageHeader + '" ></img>';
          }
        }
      }

      properties['attr'] = [
      {
        'key': '%%NOMBRE%%',
        'value': this._utf8.utf8Encode(data?.person?.givenName)
      },
      {
        'key': '%%PORTAL%%',
        'value': portal
      },
      {
        'key': '%%FONT_COLOR%%',
        'value': environment.theme.fontColor
      },
      {
        'key': '%%BACKGROUND_COLOR%%',
        'value': environment.theme.backgroundColor
      },
      {
        'key': '%%MEETDESCRIPTION%%',
        'value': text
      },
      {
        'key': '%%BACKGROUND_BORDER%%',
        'value': environment.theme.backgroundColorBorderMail
      },
      {
        'key': '%%ALIAS_APP%%',
        'value': site_header
      },
      {
        'key': '%%TEXTFOOTER%%',
        'value': !isNullOrUndefined(environment.theme.textFooterMail) ? environment.theme.textFooterMail : ''
      }];
      const email_message = {
        identifier: 1,
        dateOfThing: {},
        status: null,
        sender: null,
        text: null,
        type: 'text/html',
        subjectOf: 'Nueva reunion agendada',
        toRecipient: emailTo
      };
      const template = this._email.getTemplate(properties);
      this.emailSubscription = template.subscribe(template_mail => {
        const response = this._email.sendMail(
          email_message,
          properties,
          template_mail
        );


        this.sendMailSubscription = response.subscribe(mail_result => {
          resolve.next(mail_result);
          resolve.complete();
        }, error => {

          resolve.next(false);
          resolve.complete();

        });
      }, error => {

        resolve.next(false);
        resolve.complete();

      });


    });

  }

  emailCrearMeet(row){
//MEETDESCRIPTION
let formsDataResponse : any =this.formsDataResponse;

let transaction:any = this.rows.filter((row) => {

   return row.identifier === formsDataResponse?.idTransaction;

});

  let data  = `https://meet.jit.si/meet${this.env.theme.images}-${this.clientDetail?.identifier}-${transaction[0]?.solicitud}`;

  let  text = this.env?.theme?.images +". Fue programada una reunion de tipo ( "+ this.i18n.transform(this.i18n.transform(this.interviewType[row?.type].label))+") en fecha "+ this.toDateString(row?.interviewDate)+ ' <br><br>  <a href="'+data+'">' + data + '</a> <br><br>';

  this.sendMail(text).subscribe((event: any) => {
   console.log('enviooooo');
  });



  }




  ngOnDestroy() {


    if (this.dataInformationsSubscription) {
      this.dataInformationsSubscription.unsubscribe();
    }
  
      if (this.emailSubscription) {
      this.emailSubscription.unsubscribe();
    }
    if (this.sendMailSubscription) {
      this.sendMailSubscription.unsubscribe();
    }

    
  }



  isLegal = (clientDetail = this.clientDetail)=>{

    return   clientDetail?.personMarketType?.audienceType == 'LEGAL';

   } 


  getDataInformations() {


    if (this.dataInformationsSubscription) {
      this.dataInformationsSubscription.unsubscribe();
    }
  
    const params = {
      name:   this.isLegal(this.clientDetail)? 'briefcase$business_person$get' : 'briefcase$person$get',
      params: {
        request: {
          'id': this.isLegal(this.clientDetail)? this.clientDetail?.adminOrganization?.identifier:this.clientDetail?.person?.identifier
        },
        path: {},
        body: {}
      }
    };
  
    this.dataInformationsSubscription = this._httpService.executeRequest(params.name, params.params, true).subscribe((response: any) => {
     this.dataInformation = response;
    
    });
  
  
    
  
  }
}
